import React, { createContext, useState, useContext, useRef, useEffect, forwardRef } from 'react';
import { AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, Heading, AlertDialogBody, FormControl, Input, AlertDialogFooter, Button, useBoolean } from '@chakra-ui/react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defaultDefaults = {
  prompt: {
    title: 'Enter some data',
    buttonText: 'Submit',
    buttonColor: 'blue'
  },
  confirm: {
    title: 'Are you sure?'
  },
  "delete": {
    title: 'Are you sure?',
    body: 'Are you sure you want to delete this',
    buttonText: 'Delete',
    buttonColor: 'red'
  },
  cancel: 'Cancel'
};
var confirmContext = /*#__PURE__*/createContext({
  value: {
    type: 'confirm',
    isOpen: false,
    isLoading: false
  },
  setValue: function setValue() {},
  defaults: /*#__PURE__*/_extends({}, defaultDefaults)
});

var SubmitButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var onClick = props.onClick,
      doubleConfirm = props.doubleConfirm,
      buttonProps = props.buttonProps,
      children = props.children;

  var _useBoolean = useBoolean(false),
      check = _useBoolean[0],
      on = _useBoolean[1].on; // useEffect(() => {
  //   if (check) {
  //     const timeout = setTimeout(off, 1000);
  //     return () => clearTimeout(timeout);
  //   }
  //   return () => {};
  // }, [check, off]);


  if (!doubleConfirm) {
    return React.createElement(Button, Object.assign({
      ref: ref,
      onClick: onClick
    }, buttonProps), children);
  }

  if (check) {
    return React.createElement(Button, Object.assign({
      ref: ref,
      onClick: onClick
    }, buttonProps), children);
  }

  return React.createElement(Button, Object.assign({
    ref: ref,
    onClick: on
  }, buttonProps, {
    variant: "outline"
  }), "Are you sure?");
});

var GlobalConfirmModal = function GlobalConfirmModal() {
  var _value$data7, _value$data8, _value$data9, _value$data10, _value$data11, _value$data12, _value$data13, _value$data14, _value$data16, _value$data17, _value$data18, _value$data19, _value$data20;

  var _useContext = useContext(confirmContext),
      value = _useContext.value,
      defaults = _useContext.defaults,
      setValue = _useContext.setValue;

  var isOpen = value.isOpen;
  var confirmRef = useRef(null);

  var _useState = useState(true),
      isFormValid = _useState[0],
      setIsFormValid = _useState[1];

  var _useState2 = useState(''),
      tmp = _useState2[0],
      setTmp = _useState2[1];

  useEffect(function () {
    if (isOpen) {
      var _value$data, _value$data2;

      setTmp(((_value$data = value.data) == null ? void 0 : _value$data.defaultState) || '');
      setIsFormValid(((_value$data2 = value.data) == null ? void 0 : _value$data2.isValid) !== false);
    }
  }, [isOpen, value.data]);

  var onClose = function onClose() {
    if (value.type === 'prompt') {
      var _value$data3;

      (_value$data3 = value.data) == null ? void 0 : _value$data3.onClick(null);
    } else {
      var _value$data4;

      (_value$data4 = value.data) == null ? void 0 : _value$data4.onClick(false);
    }

    setTmp('');
    setValue(function (d) {
      return _extends({}, d, {
        data: undefined,
        isOpen: false
      });
    });
    setIsFormValid(true);
  };

  var onClick = function onClick() {
    if (value.type === 'prompt') {
      var _value$data5;

      (_value$data5 = value.data) == null ? void 0 : _value$data5.onClick(tmp);
    } else {
      var _value$data6;

      (_value$data6 = value.data) == null ? void 0 : _value$data6.onClick(true);
    }

    setTmp('');
    setValue(function (d) {
      return _extends({}, d, {
        data: undefined,
        isOpen: false
      });
    });
    setIsFormValid(true);
  };

  if (!isOpen) {
    return null;
  }

  var CustomForm = (_value$data7 = value.data) == null ? void 0 : _value$data7.customBody;
  return React.createElement(AlertDialog, {
    isOpen: isOpen,
    leastDestructiveRef: confirmRef,
    onClose: onClose,
    isCentered: (_value$data8 = value.data) == null ? void 0 : _value$data8.isCentered,
    size: (_value$data9 = value.data) == null ? void 0 : _value$data9.size
  }, React.createElement(AlertDialogOverlay, null, React.createElement(AlertDialogContent, {
    mx: "4"
  }, React.createElement(AlertDialogHeader, null, React.createElement(Heading, {
    size: "md"
  }, ((_value$data10 = value.data) == null ? void 0 : _value$data10.title) || 'Are you sure?')), (((_value$data11 = value.data) == null ? void 0 : _value$data11.actionBody) || ((_value$data12 = value.data) == null ? void 0 : _value$data12.body)) && React.createElement(AlertDialogBody, null, ((_value$data13 = value.data) == null ? void 0 : _value$data13.actionBody == null ? void 0 : _value$data13.actionBody(onClose)) || ((_value$data14 = value.data) == null ? void 0 : _value$data14.body)), value.type === 'prompt' && React.createElement(AlertDialogBody, null, React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (isFormValid) {
        onClick();
      }
    }
  }, CustomForm ? React.createElement(CustomForm, {
    state: tmp,
    onSubmit: onClick,
    onSubmitWithData: function onSubmitWithData(state) {
      var _value$data15;

      return (_value$data15 = value.data) == null ? void 0 : _value$data15.onClick(state);
    },
    setState: setTmp,
    isFormValid: isFormValid,
    setIsFormValid: setIsFormValid
  }) : React.createElement(FormControl, null, React.createElement(Input, {
    ref: confirmRef,
    value: tmp,
    onChange: function onChange(e) {
      return setTmp(e.target.value);
    }
  })))), React.createElement(AlertDialogFooter, null, React.createElement(Button, {
    onClick: onClose
  }, ((_value$data16 = value.data) == null ? void 0 : _value$data16.cancelText) || defaults.cancel), !((_value$data17 = value.data) == null ? void 0 : _value$data17.onlyAlert) && React.createElement(SubmitButton, {
    buttonProps: {
      colorScheme: ((_value$data18 = value.data) == null ? void 0 : _value$data18.buttonColor) || 'blue',
      isDisabled: !isFormValid,
      ml: 3
    },
    ref: value.type === 'prompt' ? null : confirmRef,
    onClick: onClick,
    doubleConfirm: ((_value$data19 = value.data) == null ? void 0 : _value$data19.doubleConfirm) || false
  }, ((_value$data20 = value.data) == null ? void 0 : _value$data20.buttonText) || 'Confirm')))));
};

var ConfirmContextProvider = function ConfirmContextProvider(props) {
  var children = props.children,
      defaults = props.defaults;

  var _useState3 = useState({
    isOpen: false,
    isLoading: false,
    type: 'alert'
  }),
      value = _useState3[0],
      setValue = _useState3[1];

  return React.createElement(confirmContext.Provider, {
    value: {
      value: value,
      setValue: setValue,
      defaults: {
        cancel: (defaults == null ? void 0 : defaults.cancel) || defaultDefaults.cancel,
        confirm: _extends({}, defaultDefaults == null ? void 0 : defaultDefaults.confirm, defaults == null ? void 0 : defaults.confirm),
        "delete": _extends({}, defaultDefaults == null ? void 0 : defaultDefaults["delete"], defaults == null ? void 0 : defaults["delete"])
      }
    }
  }, React.createElement(GlobalConfirmModal, null), children);
};
function useConfirm(init, type) {
  var context = useContext(confirmContext);
  return function (data) {
    return new Promise(function (resolve, _reject) {
      var _context$defaults;

      context.setValue({
        type: type || 'confirm',
        isOpen: true,
        isLoading: false,
        data: _extends({}, (_context$defaults = context.defaults) == null ? void 0 : _context$defaults.confirm, init, data, {
          onClick: resolve
        })
      });
    });
  };
}
function useConfirmDelete(init) {
  var _context$defaults2;

  var context = useContext(confirmContext);
  return useConfirm(_extends({}, (_context$defaults2 = context.defaults) == null ? void 0 : _context$defaults2["delete"], init));
}
function usePrompt(init) {
  var _context$defaults3;

  var context = useContext(confirmContext);
  var fn = useConfirm(_extends({}, (_context$defaults3 = context.defaults) == null ? void 0 : _context$defaults3.prompt, init), 'prompt');
  return fn;
}
function usePromptWithClose(init) {
  var _context$defaults4;

  var context = useContext(confirmContext);
  var fn = useConfirm(_extends({}, (_context$defaults4 = context.defaults) == null ? void 0 : _context$defaults4.prompt, init), 'prompt');
  return [fn, context];
} // experimental

function useUNSTABLE_Alert(init) {
  return useConfirm(_extends({
    onlyAlert: true
  }, init), 'alert');
}

export { ConfirmContextProvider, useConfirm, useConfirmDelete, usePrompt, usePromptWithClose, useUNSTABLE_Alert };
//# sourceMappingURL=chakra-confirm.esm.js.map
